import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../../admin-services/user.service';
import {first} from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DocManagementComponent } from '../../../components/doc-management/doc-management.component';
import { BorderedTilesInformationsComponent } from '../../../../shared/components/ux/bordered-tiles-informations/bordered-tiles-informations.component';
import { BasicInformationsComponent } from '../../../components/basic-informations/basic-informations.component';
import { UserInformationsComponent } from '../../../../shared/components/forms/user-informations/user-informations.component';
import { NgIf, NgFor, DatePipe } from '@angular/common';

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss'],
    standalone: true,
    imports: [NgIf, UserInformationsComponent, BasicInformationsComponent, BorderedTilesInformationsComponent, NgFor, DocManagementComponent, DatePipe]
})
export class UserComponent implements OnInit {


  private userId: string;
  public user: any;
  public userBoxInfos : any[];
  public isLoading:boolean = false;
  public loadingPass = false;
  public loadingMail = false;
  bookingMail;
  adminPass;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private adminUserService: UserService,
    private modalService: NgbModal
  ) { }

  @ViewChild('modal') modal: any;
  
  ngOnInit(): void {
    this.isLoading = true;
    this.userId = this.route.snapshot.paramMap.get('id');
    this.adminUserService.getUserById(this.userId).pipe(first()).subscribe(data => {
      data['name'] = ((data.firstname ? data.firstname : 'N/A') + ' ' + (data.lastname ? data.lastname : 'N/A'));
      this.user = data;
      this.setBoxInformations();
      this.isLoading = false;
    });

  }

  public goTo(): void {
    this.router.navigate(['admin/users'])
  }

  private setBoxInformations():void {
    this.userBoxInfos = [
      {
        name: 'Nationalité',
        icon: this.user.nationality && this.user.nationality.trim().length > 0 ? 'https://purecatamphetamine.github.io/country-flag-icons/3x2/'+ this.user.nationality+'.svg' :  '🏴' ,
        icon_type: this.user.nationality && this.user.nationality.trim().length > 0 ? 'img' : 'other',
        info: this.user.nationality && this.user.nationality.trim().length > 0 ? this.user.nationality : 'N/A',
        info_type: 'string',
      },
      {
        name: 'Genre',
        icon: this.user.gender === 'female' ? '👧' : (this.user.gender ? '👨' : '?'),
        icon_type: 'other',
        info: this.user.gender === 'female' ? 'COMMON.USER.GENDER_FEMALE' : (this.user.gender ? 'COMMON.USER.GENDER_MALE' : 'N/A'),
        info_type: 'clef',
      },
      {
        name: 'Ville d\'étude',
        icon: '',
        icon_type: 'other',
        info: this.user.studyPlace ? this.user.studyPlace : 'N/A',
        info_type: 'string',
      },
      {
        name: 'Langue de l\'app',
        icon: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/'+ (this.user.textLanguage == 'fr' ? 'FR' : 'GB') +'.svg',
        icon_type: 'img',
        info: this.user.textLanguage ? (this.user.textLanguage == 'fr' ? 'Français' : 'English') : 'N/A',
        info_type: 'string',
      },
      {
        name: 'Age',
        icon: '🎂',
        icon_type: 'other',
        info: this.user.birthdate,
        info_type: 'age',
      },
    ]
  }

  public deleteDocument(docId):void {
    if (docId){
      this.user.documents = this.user.documents.filter(doc => doc.id !== docId);
    }
  }

  generateAdminPass(){
    this.loadingPass = true;
    this.adminUserService.generateAdminPass(this.user.id).subscribe(data => {
      this.adminPass = data;
      this.loadingPass = false;
    });
  }

  getUserReservationMail(){
    this.loadingMail = true;
    this.adminUserService.getUserReservationMail(this.user.id).subscribe(data => {
      this.loadingMail = false;
      this.bookingMail = data.html;
      this.openModal(this.modal);
    });
  }

  openModal(template) {
    this.modalService.open(template, {centered:true, size:'lg'});
  }
}
